import Backbone from 'backbone'
import _ from 'lodash'
import Calculations from '../overview/calculations'
import Historical from '../overview/historical'
import HistoricalTable from './historical-table'
import Notes from 'scoreboard/notes/notes'
import NoteReplyForm from 'scoreboard/notes/reply-form'
import Performance from '../overview/performance'
import Related from 'scoreboard/related-items/related-items-list'
import Values from '../overview/values'
import context from '../overview/scorecards-context'
import formatValue from 'scoreboard/components/format-value'
import scorecardInfo from '../overview/scorecard-info.hbs'
import template from './scorecards-overview-export-pdf.hbs'

var children = ['export-historical', 'export-historicalTable', 'export-performance']

var ScorecardExport = Backbone.View.extend({

	className: 'export-body',

	initialize: function() {
		formatValue.unshortenByDefault()
		this.fullContext = context(this.model)
		this.performance = new Performance({ model: this.model })
		this.historical = new Historical({ model: this.model })
		this.historicalTable = new HistoricalTable({
			fullContext: this.fullContext,
			model: this.model,
			scores: _.get(this.model.get('chartData'), 'scorecards[0].scores')
		})

		this.related = new Related({ model: this.model })
		if (this.related.collection.length > 0) {
			children.push('export-related')
		}

		if (this.fullContext.metricish) {
			this.values = new Values({ model: this.model })
			children.push('export-values')
		} else {
			this.calculations = new Calculations({ model: this.model })
			children.push('export-calculations')
		}
		this.notes = new Notes(this.fullContext.notes,  { section: 'scorecards' })

		this.once('export-resize', heightAndWidth => {
			this.historical.trigger('resize', heightAndWidth)
			this.trigger('export-prepared')
		})
	},

	render: function() {
		var ctx = this.fullContext
		this.$el.empty().append(template(ctx))

		// Export specific changes from the overview-info template
		ctx.export = true
		this.$('.scorecard-info').replaceWith(scorecardInfo(ctx))
		this.$('.overview-info .panel').removeClass('panel').addClass('column-row details')

		if (!this.historicalTable.chartHasExportedScorecardItem()) {
			// #40342 if the exported scorecard item isn't actually in the chart,
			// it doesn't make sense to include the special-purpose historical
			// table in the export
			this.$('.export-historical-table').addClass('is-not-displayed')
		}

		this._renderChildren()
		this._renderNotes()
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.noteChildren, 'remove')
		_.each(children, function(child) {
			this._getChild(child).remove()
		}.bind(this))
	},

	_renderChildren: function () {
		_.each(children, function (child) {
			this._renderChild(child)
		}.bind(this))
	},

	/**
	 * append views to the DOM before rendering (speedometer needs to be in the DOM)
	 * @param child
	 * @private
	 */
	_renderChild: function (child) {
		this.$('.' + child).empty().append(this._getChild(child).el)
		this._getChild(child).render()
	},

	/**
	 * Distinct from _renderChildren because it makes use of the replyForm template
	 * repeatedly to build up the HTML for all notes
	 * @private
	 */
	_renderNotes: function () {
		this.noteChildren = []
		var noteContainer = this.$('.notes').empty()
		// this.notes is a Backbone collection
		this.notes.forEach(function (n) {
			var note = new NoteReplyForm({
				model: n,
				rootDomainObject: this.model,
				export: true
			})
			note.$el.addClass('panel')
			this.noteChildren.push(note)
			noteContainer.append(note.el)
			note.render()
		}.bind(this))

	},

	/**
	 * Returns the correct child view item when passed it's corresponding classname.
	 * Ex: _getChild('export-budget') returns this.budget
	 */
	_getChild: function(child) {
		return this[child.substring(child.indexOf('-') + 1)]
	}
})

export default ScorecardExport

ScorecardExport.__filename__ = 'scorecards/export/scorecards-overview-export-pdf.js'
